import PromocodeDetails from './components';
import withProps from './containers/withProps';

import { compose } from 'ramda';

export default compose(withProps)(PromocodeDetails);
